import React from 'react';
import {ReactComponent as InfoSvg} from '../../../../assets/icons/info.svg';
import {ReactComponent as RejectSvg} from '../../../../assets/icons/reject.svg';
import {ReactComponent as SendSvg} from '../../../../assets/icons/send.svg';
import {ReactComponent as DownloadSvg} from '../../../../assets/icons/download.svg';
import {ReactComponent as UpdateSvg} from '../../../../assets/icons/updated.svg';
import {ReactComponent as ConfirmedSvg} from '../../../../assets/icons/confirmed.svg';
import {ButtonMUI} from '../../../../shared';
import {ReactComponent as SignatureIcon} from '../../../../assets/icons/signature.svg';
import {ReactComponent as RejectIcon} from '../../../../assets/icons/reject.svg';
import LoadPanel from '../../../Components/LoadPanel';
import {notifyError} from '../../../../helpers/notifySnack';
import dayjs from 'dayjs';
import {dateFormatWithTime} from '../../../../helpers/constants';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";

const SingleDocument = ({
                            singleDocumentLoading,
                            singleDocument,
                            handleNavigate,
                            requestApproveHandler,
                            approveHandler,
                            rejectHandler,
                            isEstimate = false,
                            acceptPermission = false,
                            requestPermission = false,
                        }) => {

    const {profileMe} = useSelector((state) => state.profile);
    const isSpectatorOrClient = profileMe?.role === 'user' || profileMe?.role === 'spectator';

    const {t} = useTranslation();
    const actions = {
        created: t('SingleDocument.fileUploaded'),
        client_requested: t('SingleDocument.sentForApproval'),
        client_approved: t('SingleDocument.approved'),
        rejected: t('SingleDocument.rejected'),
        client_rejected: t('SingleDocument.rejected'),
        update: t('SingleDocument.updated'),
        approved: t('SingleDocument.approved')
    };

    if (singleDocumentLoading) {
        return <LoadPanel noBg={true} circleSize={40} staticPos={true}/>;
    }

    if (!Object.keys(singleDocument).length) {
        notifyError(t('SingleDocument.errorOpeningDocument'));
        return handleNavigate();
    }

    return (
        <div className={'projects__documents-single'}>
            <h2>{singleDocument.name}</h2>
            {!isEstimate && singleDocument.status === 'new' && requestPermission ? (
                <div className='projects__documents-button'>
                    <ButtonMUI onClick={requestApproveHandler} variant={'outlined'} size={'medium'}
                               startIcon={<SignatureIcon/>}>
                        {t('SingleDocument.requestApproval')}
                    </ButtonMUI>
                </div>
            ) : null}
            {!isEstimate && singleDocument.status === 'requested' && acceptPermission ? (
                <div className={'projects__documents-buttons'}>
                    <div className='projects__documents-button'>
                        <ButtonMUI onClick={approveHandler} variant={'outlined'} size={'medium'}
                                   startIcon={<SignatureIcon/>}>
                            {t('SingleDocument.approve')}
                        </ButtonMUI>
                    </div>
                    <div className='projects__documents-button'>
                        <ButtonMUI
                            color={'secondary'}
                            onClick={rejectHandler}
                            variant={'outlined'}
                            size={'medium'}
                            startIcon={<RejectIcon/>}
                        >
                            {t('SingleDocument.reject')}
                        </ButtonMUI>
                    </div>
                </div>
            ) : null}

            {!isEstimate && (
                <div className={`projects__item-status single ${singleDocument.status}`}>
                    <InfoSvg/>
                    {singleDocument.status === 'approved' && t('SingleDocument.approved')}
                    {singleDocument.status === 'new' && t('SingleDocument.created')}
                    {singleDocument.status === 'requested' && t('SingleDocument.waitingForApproval')}
                    {singleDocument.status === 'rejected' && t('SingleDocument.rejected')}
                </div>
            )}
            {singleDocument?.paymentStatus === 'partially_paid' || singleDocument?.paymentStatus === 'paid' ?
                <div className={`projects__item-status single ${singleDocument?.paymentStatus}`}>
                    <InfoSvg/>
                    {singleDocument?.paymentStatus === 'partially_paid' && t('all.partially_paid')}
                    {singleDocument?.paymentStatus === 'paid' && t('all.paid')}
                </div> : null}
            {singleDocument?.orderStatus === 'ordered' && !isSpectatorOrClient ?
                <div className={`projects__item-status single ${singleDocument?.orderStatus}`}>
                    <InfoSvg/>
                    {singleDocument?.orderStatus === 'ordered' && t('all.ordered')}
                </div> : null}
            <div className='projects__documents-history'>
                {Object.values(singleDocument?.history ?? []).map((item, index) => (
                    <div className={'projects__documents-el'} key={index}>
                        <div className={`projects__documents-info`}>
                            {(item.action === 'download' || item.action === 'created') && (
                                <div className='projects__documents-icon projects__documents-icon--download'>
                                    <DownloadSvg/>
                                </div>
                            )}
                            {item.action === 'client_requested' && (
                                <div className='projects__documents-icon projects__documents-icon--send'>
                                    <SendSvg/>
                                </div>
                            )}
                            {(item.action === 'rejected' || item.action === 'client_rejected') && (
                                <div className='projects__documents-icon projects__documents-icon--reject'>
                                    <RejectSvg/>
                                </div>
                            )}
                            {item.action === 'updated' && (
                                <div className='projects__documents-icon projects__documents-icon--updated'>
                                    <UpdateSvg/>
                                </div>
                            )}
                            {item.action === 'client_approved' || item.action === 'approved' ? (
                                <div className='projects__documents-icon projects__documents-icon--approved'>
                                    <ConfirmedSvg/>
                                </div>
                            ) : null}
                        </div>
                        <div className='projects__documents-data'>
                            <div className={'projects__documents-action'}>{actions[item.action] ?? ''}</div>
                            <div
                                className='projects__documents-caption'>{dayjs(item.createdAt).format(dateFormatWithTime)}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SingleDocument;
